import {QuestionSetup} from "./models/definitions/QuestionSetup";
import {FormSetup} from "./models/definitions/FormSetup";

/**
 * clones the question or form setup and removes readonly fields
 */
export function cloneSetup(setup: QuestionSetup | FormSetup): any {
	return deepCloneAndFilterReadonlyFields(setup);
}

function deepCloneAndFilterReadonlyFields(obj: any): any {
	if (Array.isArray(obj))
		return obj.map(deepCloneAndFilterReadonlyFields);
	
	if (typeof obj === "object") {
		const copy: any = {};
		for (const key in obj) {
			if (key === "fullId") continue;
			if (key === "formId") continue;
			if (key === "versionId") continue;
			if (key === "creationDateTime") continue;
			if (key === "lastModifiedDateTime") continue;
			if (key === "lastModifiedBy") continue;
			// noinspection JSUnfilteredForInLoop
			const value = obj[key];
			
			if (value === undefined) continue;
			if (value === null) continue;
			
			// noinspection JSUnfilteredForInLoop
			copy[key] = deepCloneAndFilterReadonlyFields(value);
		}
		return copy;
	}
	
	return obj;
}
